import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Notifications from 'react-notify-toast';
import NProgress from 'nprogress'

import Home from './Home';
import Explore from './explore/Explore';
import Artist from './artist/Artist';
import Track from './track/Track';
import Album from './album/Album';
import Tag from './tag/Tag';
import LastfmUser from './lastfm_user/LastfmUser';
import User from './user/User';
import PasswordRecoveryForm from './credentials/PasswordRecoveryForm';
import SearchResult from './SearchResult';
import Header from './Header';
import Player from './Player';
import MapGraph from './Map';
import RiverGraph from './River';
import TreemapGraph from './Treemap';
import TwitterSignup from './signup/TwitterSignup';
import TwitterCredentials from './twitter/TwitterCredentials';
import ServiceAuthorization from './user/ServiceAuthorization';
import NoMatch from './NoMatch';
import withTracker from './withTracker';
import GoogleSignIn from './credentials/GoogleSignIn';

import '../../css/normalize.css';
import '../../css/App.css';
import '../../css/nprogress.css';
import '../../css/fontastic.css';

class App extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {}
    NProgress.configure({ showSpinner: false });
    NProgress.configure({ easing: 'ease', speed: 600 });
    NProgress.configure({ trickleRate: 0.1, trickleSpeed: 1000 });
  }

  render() {

    

    if (window.localStorage.getItem('googleToken') === null) {
      return (
        <Router>
          <div id="App" className="App not-selectable">
            <Notifications/>
            <Switch>   
              <Route exact path="/" component={withTracker(GoogleSignIn)}/>
              <Route path="/authorize/:service" component={withTracker(ServiceAuthorization)}/>
              <Route component={withTracker(NoMatch)}/>
            </Switch>
          </div>
        </Router>
      );
    }

    return (

      <Router>   

        <div id="App" className="App not-selectable">

          <Notifications/>

          <Header/>
      
          <div id="container">
            <Switch>   
              <Route exact path="/" component={withTracker(Home)}/>
              <Route path="/about" component={withTracker(Home)}/>
              <Route path="/maps/:context/:searchTerm/:mapType/:mapTypeTerm?" component={withTracker(MapGraph)}/>
              <Route path="/rivers/:context/:searchTerm/:riverType/:riverTypeTerm?" component={withTracker(RiverGraph)}/>
              <Route path="/treemaps/:context/:searchTerm/:treemapType/:treemapTypeTerm?" component={withTracker(TreemapGraph)}/>
              <Route>
                <div className="container">
                  <Switch> 
                    <Route path="/explore" component={withTracker(Explore)}/>
                    <Route path="/lastfm-users/:user" component={withTracker(LastfmUser)}/>
                    <Route path="/users/:user" component={withTracker(User)}/>
                    <Route path="/artists/:artist/albums/:album" component={withTracker(Album)}/>
                    <Route path="/artists/:artist/tracks/:track" component={withTracker(Track)}/>
                    <Route path="/artists/:artist" component={withTracker(Artist)}/>
                    <Route path="/tags/:tag" component={withTracker(Tag)}/>
                    <Route path="/search/:query?" component={withTracker(SearchResult)}/>
                    <Route path="/signup/twitter" component={withTracker(TwitterSignup)}/>
                    <Route path="/password_recovery/:token?" component={withTracker(PasswordRecoveryForm)}/>
                    <Route path="/twitter/credentials" component={withTracker(TwitterCredentials)}/>
                    <Route path="/authorize/:service" component={withTracker(ServiceAuthorization)}/>
                    <Route component={withTracker(NoMatch)}/>
                  </Switch>
                </div>
              </Route>
            </Switch>
          </div>

        <Player/>

      </div>

    </Router>     

    );
    
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/components/App.jsx